import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
  remCalc,
  translate,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import Footer from './HelpAndSupportFooter';
import Tiles from './HelpAndSupportTiles';

const t = (key: string, options?) => translate('helpAndSupport', key, options);

const HelpAndSupportContainer: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        justifyItems: 'center',
        gridGap: remCalc(24),
        marginTop: remCalc(40),
      }}
    >
      <Typography variant="h2" component="h1" style={{ fontWeight: 'bold' }}>
        {t('howCanWeHelpYou')}
      </Typography>
      <Tiles />
      <Footer />
    </Box>
  );
};

export default HelpAndSupportContainer;
